import React from 'react';
import { and, not } from 'ramda';
import LogoOrange from '../../../../assets/brand/logo-orange.svg';
import LogoWhite from '../../../../assets/brand/logo-white.svg';
import LogoCredicorpBlack from '../../../../assets/brand/logo-credicorp-black.svg';
import LogoCredicorpWhite from '../../../../assets/brand/logo-credicorp-white.svg';
import { useResponsive } from '../../../shared/hooks';
import { BackButton } from './components';
import { HeaderWrapper, LogoStyled, SloganStyled } from './styles';

const Header = (props) => {

  const { whitBackBtn = false, white = false, onlyBackBtn = false } = props;

  if (onlyBackBtn) return (
    <HeaderWrapper {...props} >
      <BackButton />
    </HeaderWrapper>
  )

  return (
    <HeaderWrapper {...props} >
      {
        whitBackBtn ? <BackButton /> : <LogoStyled src={white ? LogoWhite : LogoOrange} loading='lazy' alt='logo' />
      }
      <SloganStyled src={white ? LogoCredicorpWhite : LogoCredicorpBlack} loading='lazy' alt='slogan' />
    </HeaderWrapper>
  )
};

const HeaderLayer = (props) => {

  const { show = true, showInMobile = true, overlayHeaderMobile = false, whitBackBtn = false } = props;

  const { xs, sm } = useResponsive();

  if (not(show)) return <></>;

  if (and(not(xs), not(sm))) return <Header {...props} />;

  if (overlayHeaderMobile && whitBackBtn)  return <Header {...props} onlyBackBtn />;

  if (not(showInMobile)) return <></>;

  return <Header {...props} />;
}

export default HeaderLayer;